import React from "react";
import styled from "styled-components";
import ProgressBar from "../ProgressBar";

const StyledProgressBox = styled.div`
  text-align: center;
  box-shadow: ${props => props.theme.boxShadow};
  background: white;
  .lessonsCompleted {
    margin-bottom: 20px;
  }
`;

const ProgressBox = ({ completed, total }) => {
  return (
    <StyledProgressBox className="innerPadding">
      <div className="lessonsCompleted">{`${completed} of ${total} Lessons Completed`}</div>
      <ProgressBar percentageComplete={completed / total} />
    </StyledProgressBox>
  );
};

export default ProgressBox;
